import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import transactionHistoryIcon from '@app/assets/images/icons/sys/invoice.svg';
import TransactionHistory from '@modules/school-service/pages/TransactionHistoryPage';
import { IRouteConfig } from '../route.types';

/**
 * Lịch sử giao dịch
 */
const transactionHistoryRoutes: IRouteConfig[] = [
    {
        name: 'LỊCH SỬ GIAO DỊCH',
        icon: transactionHistoryIcon,
        isMenu: true,
        isRoute: true,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        functionId: ADMIN_FUNCTIONS.TRANSACTION_HISTORY,
        link: '/transaction-history',
        path: '/transaction-history',
        main: () => <TransactionHistory />,
    },
];

export default transactionHistoryRoutes;
